// extracted by mini-css-extract-plugin
module.exports = {"formsPhoneVerification":"_2fZRieR6g87FJaMYGMuzD2"};